import validator from './validator';
import location from './location';
import product from './product';
import profile from './profile';

const conditions = {
  location,
  product,
  profile,
};

export default function (modelName, model) {
  return validator(model, conditions[modelName], modelName);
}



// WEBPACK FOOTER //
// ./src/app/utils/marketing-readiness/index.js